export const LINK = {
  form: `/form`,
};
